/**
 * External dependencies
 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';

/**
 * Internal dependencies
 */
import { hasSidebar, isSectionLoading, getSectionName } from 'state/ui/selectors';
import DocumentHead from 'data/document-head';
import GlobalNotices from 'blocks/global-notices';
import LoggedInTopbar from './topbar/logged-in';
import cscom from 'lib/customer-site-api';

class Layout extends Component {

	static propTypes = {
		primary: PropTypes.element,
		secondary: PropTypes.element,
	};

	state = {
		serverVersion: null,
	};

	componentDidMount() {
		cscom.version().show()
			.then(response => this.setState({ serverVersion: response.version }))
			.catch(() => {});
	}

	render() {
		const sectionClass = classnames(
			'layout',
			{ 'has-no-sidebar': !this.props.hasSidebar },
			{ 'has-no-sidebar': !this.props.hasSidebar },
			`is-section-${this.props.sectionName}`,
		);

		const loadingClass = classnames({
			layout__loader: true,
			'is-active': this.props.isLoading,
		});

		return (
			<div className={sectionClass}>
				<DocumentHead />
				<GlobalNotices />
				<LoggedInTopbar />
				<div className={loadingClass}>{this.props.isLoading && <div>loading!</div>}</div>
				<div id='content' className='layout__content'>
					<div id='secondary' className='layout__secondary' role='navigation'>
						{this.props.secondary}
					</div>
					<div id='primary' className='layout__primary'>
						{this.props.primary}
					</div>
				</div>
				<footer className='footer__container'>
					<div className='footer__content'>
						<span>© TOWER SYSTEMS PTY LTD. <a href="//towersystems.com.au/terms-and-conditions.html">Terms & Conditions</a></span>
						{this.state.serverVersion && <span className='footer__version'>v{this.state.serverVersion}</span>}
					</div>
				</footer>
			</div>
		);
	}
	
}

const mapStateToProps = (state) => {
	return {
		hasSidebar: hasSidebar(state),
		isLoading: isSectionLoading(state),
		sectionName: getSectionName(state),
	};
};

export default connect(
	mapStateToProps,
	{},
)(Layout);
